export default __webpack_public_path__ + "static/Plots0073-e9c04ed3b53a0fa54e02c34a07af513b.jpg";